import React, { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import IDSTable from "./IDSTable";
import Button from "react-bootstrap/Button";
import { useNavigate, useLocation } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import InputAdornment from "@mui/material/InputAdornment";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Accordion from "react-bootstrap/Accordion";
import Form from "react-bootstrap/Form";
import Alert from "react-bootstrap/Alert";
import { ERROR_MSG, S3_URL } from "../services/Constants";
import {
  fetchRuleData,
  removeRuleRecord,
  removeBusinessRuleRecord,
} from "../services/rules-services";
import { rulesHeadCells } from "../util/headcells-util";
import { useContext } from "react";
import UserContext from "../context/user-context";
import { componentIsVisible, validateAndSanitizeUrl } from "../util/common";
import { RTRB } from "../util/component-codes";
import Cookies from "js-cookie";

const RulesTable = () => {
  const location = useLocation();
  const [showRemoveWarningModal, setShowRemoveWarningModal] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
    const [filter, setFilter] = useState(
    location?.state?.filter ? location?.state?.filter : {}
  );
const [isDeleted, setIsDeleted] = useState(false);
  const [alertMessage, setAlertMessage] = useState();

  const [selectedRow, setSelectedRow] = useState(null);
  const [rulesData, setRulesData] = useState(null);
  const [recordsPerPage, setRecordsPerPage] = useState(Cookies.get("itemsPerPage")?Cookies.get("itemsPerPage"):5);
  const [pageNo, setPageNo] = useState(location?.state?.pageNo ? location?.state?.pageNo : 0 );
  const [isFetchError, setIsFetchError] = useState(false);

  const [user] = useContext(UserContext);

  const handleError = () => {
    let value = false;
    if (location?.state?.isAdded != null) {
      value = !location?.state?.isAdded;
    } else if (location?.state?.isUpdated != null) {
      value = !location?.state?.isUpdated;
    }
    if (location?.state?.success === false) value = true;
    return value;
  };
  const [isError, setIsError] = useState(handleError());
  const [isAdded, setIsAdded] = useState(
    location?.state?.isAdded != null ? location?.state?.isAdded : false
  );
  const [isUpdated, setIsUpdated] = useState(
    location?.state?.isUpdated != null ? location?.state?.isUpdated : false
  );

  const handleRemoveWarningModalClose = () => setShowRemoveWarningModal(false);
  const handleFilterModalClose = () => setShowFilterModal(false);

  const urlWithParams = (filter) => {
    let sendingFacilityName = filter?.searchText ? filter?.searchText : "";
    let ruleCategory = [];
    let isActive = [];

    if (filter?.business) {
      ruleCategory.push("Business");
    }
    if (filter?.translation) {
      ruleCategory.push("Translation");
    }
    if (filter?.validation) {
      ruleCategory.push("Validation");
    }
    if (filter?.active) {
      isActive.push("true");
    }
    if (filter?.inactive) {
      isActive.push("false");
    }

    let params = "";

    if (sendingFacilityName !== "") {
      params += `&sendingFacilityName=${sendingFacilityName}`;
    }
    if (ruleCategory.length > 0) {
      params += `&ruleCategory=${ruleCategory.toString()}`;
    }
    if (isActive.length > 0) {
      params += `&isActive=${isActive.toString()}`;
    }

    return params;
  };

  const getRuleData = useCallback(
    async (filter) => {
      let response = await fetchRuleData(
        pageNo,
        recordsPerPage,
        urlWithParams(filter)
      );

      if (response.ok) {
        let data = await response.json();
        if (data.genericList != null) {
          setRulesData(data);
        } else {
          setIsFetchError(true);
          setIsError(true);
          setAlertMessage(data?.description);
        }
      } else {
        setIsFetchError(true);
        let error = await response.json();
        setIsError(true);
        setAlertMessage(error?.description);
      }
    },
    [pageNo, recordsPerPage]
  );

  const removeRule = async () => {
    let response = ERROR_MSG;
    if (selectedRow.ruleCategory === "Business")
      response = await removeBusinessRuleRecord(selectedRow.ruleId);
    else response = await removeRuleRecord(selectedRow.ruleId);

    if (response.ok) {
      setIsDeleted(true);
      setSelectedRow(null);
    } else {
      let error = await response.json();
      setIsError(true);
      setAlertMessage(error?.description);
    }

    handleRemoveWarningModalClose();
  };

  useEffect(() => {
    getRuleData(filter);
  }, [pageNo, recordsPerPage, getRuleData]);

  useEffect(() => {
    if (isAdded || isUpdated || isDeleted) {
      getRuleData(filter);
    }
  }, [isAdded, isUpdated, isDeleted, getRuleData]);
  
  useEffect(() => {
    if (pageNo >= rulesData?.totalPages) {
      rulesData?.totalPages !== 0 && setPageNo(rulesData?.totalPages - 1);
    }
  }, [rulesData]);

  const setFilterField = (field, value) => {
    setFilter({
      ...filter,
      [field]: value,
    });
  };

  const navigate = useNavigate();

  const handleAddRule = () => {
    navigate("/rulesScreen", {
      state: { landingTab: "1", from: "rulesTable",  filter:filter,
        pageNo:pageNo, },
    });
  };

  const handleShowFilter = () => {
    setIsAdded(false);
    setIsUpdated(false);
    setIsDeleted(false);
    setIsError(false);
    setShowFilterModal(true);
  };

  const handleUpdate = () => {
    let landingTab = "1";
    if (selectedRow.ruleCategory === "Translation") {
      landingTab = "2";
    } else if (selectedRow.ruleCategory === "Validation") {
      landingTab = "3";
    }
    navigate("/rulesScreen", {
      state: {
        landingTab: landingTab,
        from: "rulesTable",
        action: "update",
        selectedRow: selectedRow,
        filter:filter,
        pageNo:pageNo,
      },
    });
  };

  const handleRemove = () => {
    setShowRemoveWarningModal(true);
    setIsDeleted(false);
    setIsError(false);
    setIsAdded(false);
    setIsUpdated(false);
  };

  const handleFilter = (event) => {
    event.preventDefault();
    setPageNo(0);
    pageNo === 0 && getRuleData(filter);
    handleFilterModalClose();
  };

  const handleResetFilter = () => {
    setFilter({});
  };

  const setSelectedRowCallback = (row) => {
    setSelectedRow(row);
  };

  const setRecordsPerPageCallback = (value) => {
    setRecordsPerPage(value);
  };

  const setPageNoCallback = (value) => {
    setPageNo(value);
  };

  const buttonsLayout = () => {
    return (
      <div className="flexCenter">
        <Button
          className="updateButtonStyle generalFont flexCenter"
          onClick={handleUpdate}
          disabled={selectedRow == null}
        >
          <img
            src={`${validateAndSanitizeUrl(S3_URL)}update-icon.png`}
            className="buttonIcon"
            alt=""
          ></img>
          Update
        </Button>
        {componentIsVisible(RTRB, user) && (
          <Button
            className="removeButtonStyle generalFont flexCenter"
            onClick={handleRemove}
            disabled={selectedRow == null}
          >
            <img
              src={`${validateAndSanitizeUrl(S3_URL)}delete-icon.png`}
              className="buttonIcon"
              alt=""
            ></img>
            Remove
          </Button>
        )}
      </div>
    );
  };

  const renderBannerMessage = () => {
    window.scrollTo(0, 0);

    if (isDeleted) {
      return "Successfully deleted Rule record";
    } else if (isAdded) {
      return "Successfully added Rule";
    } else if (isUpdated) {
      return "Successfully updated Rule";
    } else if (isError) {
      return alertMessage
        ? alertMessage
        : "Something went wrong, please try again";
    }
  };

  const setExpandedAccordion = () => {
    let active = [];
    if (filter?.translation || filter?.validation || filter?.business) {
      active.push("0");
    }
    if (filter?.active || filter?.inactive) {
      active.push("1");
    }
    return active;
  };

  return (
    <>
      <Container fluid className="loincContainer">
        <Row style={{ marginLeft: "0px" }}>
          <Col xl={8}>
            <Row className="tableTitle generalFont">Rules Management</Row>
            <Row className="tableSubtitle generalFont">
              View all the rules registered within the rules engine
            </Row>
          </Col>
        </Row>
        {(isAdded || isUpdated || isDeleted || isError) && (
          <Alert
            style={{ marginRight: "125px" }}
            key={"success"}
            variant={isError ? "danger" : "success"}
            onClose={() => {
              setIsAdded(false);
              setIsUpdated(false);
              setIsDeleted(false);
              setIsError(false);
            }}
            dismissible
          >
            {renderBannerMessage()}
          </Alert>
        )}
        <IDSTable
          isFetchError={isFetchError}
          setPageNoCallback={setPageNoCallback}
          setRecordsPerPageCallback={setRecordsPerPageCallback}
          headCells={rulesHeadCells}
          rows={rulesData?.genericList}
          pages={rulesData?.totalPages}
          buttonsLayout={buttonsLayout}
          addButtonName="Add New Rule"
          addButtonAction={handleAddRule}
          setSelectedRowCallback={setSelectedRowCallback}
          handleShowFilter={handleShowFilter}
          isRulesTable={true}
          filter={filter}
          pageNo={pageNo}
        />
      </Container>
      <Modal
        show={showRemoveWarningModal}
        onHide={handleRemoveWarningModalClose}
        size="lg"
        centered
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Remove Rule
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              Are you sure you want to remove this Rule from the Table?
            </Form.Label>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer className="modalFooterContainer">
          <Button
            onClick={handleRemoveWarningModalClose}
            className="modalCancelStyle generalFont flexCenter"
            variant="secondary"
          >
            Cancel
          </Button>
          <Button
            onClick={removeRule}
            className="modalRemoveStyle generalFont flexCenter"
          >
            Remove
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showFilterModal}
        onHide={handleFilterModalClose}
        size="sm"
        centered
        dialogClassName="my-modal-30"
      >
        <Modal.Header className="modalHeaderContainer" closeButton>
          <Modal.Title className="modalHeader generalFont">
            Apply Filters
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="modalBodyContainer">
          <React.Fragment>
            <Form.Label className="modalLabel generalFont">
              <TextField
                className="my-modal-searchbox-30"
                size="small"
                placeholder="Search Facility"
                value={filter.searchText ? filter.searchText : ""}
                onChange={(e) => setFilterField("searchText", e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <img
                        src={`${validateAndSanitizeUrl(S3_URL)}search-icon.png`}
                        alt=""
                        style={{ height: "19px", width: "19px" }}
                      ></img>
                    </InputAdornment>
                  ),
                }}
              />
            </Form.Label>
            <br />
            <br />
            <Accordion
              alwaysOpen
              disablegutters="true"
              defaultActiveKey={setExpandedAccordion()}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Header>
                  <div className="bold">Rule Type</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Translation"
                      checked={filter.translation ? true : false}
                      onChange={(e) =>
                        setFilterField("translation", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Validation"
                      checked={filter.validation ? true : false}
                      onChange={(e) =>
                        setFilterField("validation", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Business"
                      checked={filter.business ? true : false}
                      onChange={(e) =>
                        setFilterField("business", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
              <br />
              <Accordion.Item eventKey="1">
                <Accordion.Header>
                  <div className="bold">Status</div>
                </Accordion.Header>
                <Accordion.Body>
                  <FormGroup>
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Active"
                      checked={filter.active ? true : false}
                      onChange={(e) =>
                        setFilterField("active", e.target.checked)
                      }
                    />
                    <FormControlLabel
                      control={<Checkbox />}
                      label="Inactive"
                      checked={filter.inactive ? true : false}
                      onChange={(e) =>
                        setFilterField("inactive", e.target.checked)
                      }
                    />
                  </FormGroup>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </React.Fragment>
        </Modal.Body>
        <Modal.Footer
          className="modalFooterContainer"
          style={{ justifyContent: "space-between", marginLeft: "23px" }}
        >
          <Button
            onClick={handleResetFilter}
            className="modalAddUpdateStyle generalFont flexCenter modalRemoveStyle"
          >
            Reset
          </Button>
          <Button
            onClick={handleFilter}
            className="modalAddUpdateStyle generalFont flexCenter"
          >
            Filter
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default RulesTable;
